import { createReducer, on } from '@ngrx/store';
import * as UpdateAccountActions from '../actions/update-account.actions';

export const updateAccountFeatureKey = 'updateAccount';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UpdateAccountActions.updateAccount, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UpdateAccountActions.updateAccountSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UpdateAccountActions.updateAccountFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UpdateAccountActions.clearUpdateAccountState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
